import { Component, OnInit } from '@angular/core';
import { SapiService } from '../../services/sapi.service';
import { OverlayService } from '../../services/overlay.service';
import { ChartDataset } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
	templateUrl: './publication-usage-stats.component.html',
	styleUrls: ['./publication-usage-stats.component.scss']
})

export class PublicationUsageStatsComponent implements OnInit {
	trafficDatasets: ChartDataset[];
	storageDatasets: ChartDataset[];
	loading = false;
	currentMonth = (new Date()).toLocaleString('default', { month: 'long' });
	projectedStorage: string;

	constructor(
		private overlayService: OverlayService,
		private sapiService: SapiService,
		private translate: TranslateService,
	) { }

	ngOnInit() {
		this.getUsageStats();
	}

	getUsageStats() {
		this.loading = true;
		this.overlayService.setLoading(true);
		const trafficData = [];
		const storageData = [];

		this.sapiService.getUrl('/publication/getUsage').subscribe((usageData) => {
			if (usageData && Object.keys(usageData).length) {
				Object.keys(usageData).forEach((dateKey) => {
					const d = new Date(dateKey);
					if (d && !isNaN(d.getTime())) {
						// Valid date
						const monthName = d.toLocaleString('default', { month: 'long' });
						const monthLabel = monthName + ' \'' + String(d.getFullYear()).substring(2, 4);
						if (this.currentMonth === monthName) {
							const currentDate = new Date().getDate();
							this.projectedStorage = ((this.getDaysInMonth(d) / currentDate) * parseFloat(usageData[dateKey].storage)).toFixed(2);
						}
						trafficData.push({
							x: monthLabel,
							y: parseFloat(usageData[dateKey].traffic)
						});
						storageData.push({
							x: monthLabel,
							y: parseFloat(usageData[dateKey].storage)
						});
					}
				});

				this.trafficDatasets = [];

				const trafficDataset: ChartDataset = {
					label: 'GB',
					data: trafficData,
					backgroundColor: ['#7ab1df'],
					borderColor: ['#7ab1df'],
					borderWidth: 1
				};

				this.trafficDatasets.push(trafficDataset);

				this.storageDatasets = [];

				const storageDataset: ChartDataset = {
					label: this.translate.instant('GB_MONTH'),
					data: storageData,
					backgroundColor: ['#7ab1df'],
					borderColor: ['#7ab1df'],
					borderWidth: 1
				};

				this.storageDatasets.push(storageDataset);

			}
			this.loading = false;
			this.overlayService.setLoading(false);
		});
	}

	getDaysInMonth(d: Date) {
		const numDays = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
		return numDays;
	}
}
